import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fbfddf58"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper pl20 pr20"
};
const _hoisted_2 = {
  class: "tabs mb30 flex_FAC"
};
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.tabs, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([$setup.data.messageType == index && 'tabs_active']),
      key: index,
      onClick: () => $setup.changeMessageType(index)
    }, [_createElementVNode("span", {
      class: _normalizeClass([$setup.data.messageType == index && 'text_blue'])
    }, "●", 2), _createTextVNode(" " + _toDisplayString(item), 1)], 10, _hoisted_3);
  }), 128))]), _createVNode(_component_el_table, {
    data: $setup.data.list,
    style: {
      "width": "95%"
    }
  }, {
    empty: _withCtx(() => [_createVNode(_component_el_empty, {
      description: "暂无数据"
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "title",
      label: "标题"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_badge, {
        value: "新",
        class: "mt10",
        hidden: scope.row.read
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.title), 1)]),
        _: 2
      }, 1032, ["hidden"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "content",
      label: "内容"
    }), _createVNode(_component_el_table_column, {
      fixed: "right",
      label: "操作"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button, {
        link: "",
        type: "primary",
        onClick: () => $setup.viewDetail(scope.$index)
      }, {
        default: _withCtx(() => [_createTextVNode("查看")]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    "page-size": $setup.data.size,
    class: "mt20",
    background: "",
    layout: "pager,total",
    total: $setup.data.total,
    onCurrentChange: $setup.currentChange
  }, null, 8, ["page-size", "total", "onCurrentChange"])]);
}